import React, { useEffect } from "react";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { headers } from "./utils"

const AuditNotificationComponent = ({  fetchAuditLogs,ticketId }) => {
  useEffect(() => {
    const socket = new SockJS(process.env.REACT_APP_AUDITLOG + "/ws"); // Use SockJS for compatibility
    const client = new Client({
      webSocketFactory: () => socket,
      onConnect: () => {
        client.subscribe("/topic/auditUpdate?id="+ticketId, (message) => {
          console.log("📩 New AUDIT ", message.body);

          fetchAuditLogs()
        });
      },
      onStompError: (frame) => {
        console.error("❌ WebSocket Error: ", frame);
      },
    });

    client.activate();

    return () => {
      client.deactivate();
    };
  }, []);

};

export default AuditNotificationComponent;
